import { render, staticRenderFns } from "./FanBase.vue?vue&type=template&id=acc54696&scoped=true"
import script from "./FanBase.vue?vue&type=script&lang=js"
export * from "./FanBase.vue?vue&type=script&lang=js"
import style0 from "./FanBase.vue?vue&type=style&index=0&id=acc54696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc54696",
  null
  
)

export default component.exports